import React, { memo, useCallback } from 'react';
import Link from '../link';
import dailyWebviewComm from '../../utils/daily-webview-comm';
import cx from 'classnames';
import styles from './index.less';
import { isJianghuDaily } from 'detect-mobile-device';

/**
 * 切换推栏账号
 * @constructor
 */
const SwitchTuilanAccount = props => {
  const { className, useDarkColor, onClick, ...rest } = props;

  const handleClick = useCallback(
    e => {
      onClick(e, props);
    },
    [onClick, props]
  );

  if (!isJianghuDaily()) {
    return null;
  }

  return (
    <Link className={cx(styles.root, className)} lockAsync onClick={handleClick} clickEffect="opacity" {...rest}>
      <svg viewBox="0 15 50 20" fill={useDarkColor ? '#4d2a3a' : '#dedede'}>
        <path d="M44.0001,29.0001 C44.8311,29.0001 45.5741,29.5131 45.8701,30.2891 C46.1651,31.0651 45.9491,31.9431 45.3291,32.4951 L45.3291,32.4951 L36.3291,40.4951 C35.9561,40.8271 35.4801,41.0001 35.0001,41.0001 C34.7231,41.0001 34.4431,40.9421 34.1811,40.8241 C33.4621,40.5021 33.0001,39.7871 33.0001,39.0001 L33.0001,39.0001 L33.0001,33.0001 L4.0001,33.0001 C2.8951,33.0001 2.0001,32.1041 2.0001,31.0001 C2.0001,29.8961 2.8951,29.0001 4.0001,29.0001 L4.0001,29.0001 Z M11.6711,7.5051 C12.2591,6.9821 13.1011,6.8531 13.8191,7.1751 C14.5381,7.4981 15.0001,8.2121 15.0001,9.0001 L15.0001,9.0001 L15.0001,15.0001 L44.0001,15.0001 C45.1051,15.0001 46.0001,15.8961 46.0001,17.0001 C46.0001,18.1041 45.1051,19.0001 44.0001,19.0001 L44.0001,19.0001 L4.0001,19.0001 C3.1691,19.0001 2.4261,18.4871 2.1301,17.7111 C1.8351,16.9351 2.0511,16.0571 2.6711,15.5051 L2.6711,15.5051 Z" />
      </svg>
    </Link>
  );
};

SwitchTuilanAccount.defaultProps = {
  onClick: (e, props) => {
    return dailyWebviewComm.showAccountModal(props.selectRole);
  },
  useDarkColor: true
};

export default memo(SwitchTuilanAccount);
